<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        fill-opacity=".24"
        d="M48 22L48 26 40 26 40 22z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".8"
        d="M8 22L8 26 0 26 0 22z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".4"
        d="M37.732 43.785L34.268 45.785 30.268 38.856 33.732 36.856z"
        transform="translate(8 8)"
      />
      <path
        d="M17.732 9.144L14.268 11.144 10.268 4.215 13.732 2.215z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".32"
        d="M45.785 34.268L43.785 37.732 36.856 33.732 38.856 30.268z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".96"
        d="M11.144 14.268L9.144 17.732 2.215 13.732 4.215 10.268z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".48"
        d="M26 40L26 48 22 48 22 40z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".04"
        d="M26 0L26 8 22 8 22 0z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".64"
        d="M14.268 36.856L17.732 38.856 13.732 45.785 10.268 43.785z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".72"
        d="M9.144 30.268L11.144 33.732 4.215 37.732 2.215 34.268z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".16"
        d="M43.785 10.268L45.785 13.732 38.856 17.732 36.856 14.268z"
        transform="translate(8 8)"
      />
      <path
        fill-opacity=".08"
        d="M34.268 2.215L37.732 4.215 33.732 11.144 30.268 9.144z"
        transform="translate(8 8)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconLoader'
}
</script>
